import api from '../api/api';

export const COURIER_TOKEN = 'prokatprost_courier_token';
const config = token => ({ isolatedAuth: true, skipLoading: true, authToken: token, timeout: 15000 });
export const courierApi = {
  login: (email, password) => api.post('/login/', { email, password }, config(null)),
  me: token => api.get('/locker/courier/me', config(token)),
  scan: (token, code) => api.get('/locker/courier/scan', { ...config(token), params: { code } }),
  receive: (token, code, requestId) => api.post('/locker/courier/receive', { code, request_id: requestId }, config(token)),
  accessCode: token => api.post('/locker/courier/access-code', {}, config(token)),
};
